import { ShippingReport, ShippingReportUpdate } from "../types/shippingReports";

export function missingShippingReportRequirements(report: ShippingReport, values: ShippingReportUpdate): string[] {
  const missing: string[] = [];
  const required: [keyof ShippingReportUpdate, string][] = [
    ["carrier_name", "Carrier name"], ["driver_name", "Driver name"],
    ["trailer_number", "Trailer number"], ["trailer_plate_number", "Trailer plate number"],
    ["arrival_at", "Arrival time"], ["started_at", "Start time"],
    ["departure_at", "Truck departure time"], ["completed_at", "Completion time"],
    ["notes", "Notes"],
  ];
  required.forEach(([field, label]) => { if (!values[field]?.trim()) missing.push(label); });
  if (report.sun_order_id) {
    if (!report.customer_name?.trim()) missing.push("Customer name");
  } else {
    if (!report.shipments?.length) missing.push("At least one shipment");
    report.shipments?.forEach(shipment => {
      if (!shipment.po_number?.trim()) missing.push(`PO number for shipment #${shipment.id}`);
      if (!shipment.customer_name?.trim()) missing.push(`Customer name for shipment #${shipment.id}`);
    });
  }
  const hasReading = (readings: ShippingReport["arrival_temperature_readings"]) =>
    readings?.some(reading => reading.temperature_celsius != null && reading.recorded_at && reading.image_path?.trim());
  if (!hasReading(report.arrival_temperature_readings)) missing.push("Arrival temperature reading with a picture");
  if (!hasReading(report.departure_temperature_readings)) missing.push("Departure temperature reading with a picture");
  if (!report.images?.some(image => image.type === "bol" && image.file_path?.trim())) missing.push("Bill of lading picture");
  return missing;
}
